import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Flex, Image } from "antd";
import { FC, ReactNode } from "react";
import { TaskPhotosEntity, TaskStatus } from "tm-shared/types";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { getFileUrl } from "@/utils/file/getFileUrl";

import { StatusIconContainer, StyledCard } from "./Styled";

interface SubtaskCardProps {
    subtask: TaskPhotosEntity;
    title?: string | ReactNode;
    children?: ReactNode;
}

export const SubtaskCard: FC<SubtaskCardProps> = ({
    subtask,
    title,
    children,
}) => {
    const { photos, comment, status } = subtask;

    const normalizeStatus =
        status === TaskStatus.Completed || status === undefined;

    return (
        <StyledCard $status={normalizeStatus}>
            <Flex vertical gap={12}>
                <StatusIconContainer $status={normalizeStatus}>
                    {normalizeStatus ? <CheckOutlined /> : <CloseOutlined />}
                </StatusIconContainer>

                {title && typeof title === "string" ? (
                    <PrimaryText>{title}</PrimaryText>
                ) : (
                    title
                )}

                {photos && photos.length > 0 && (
                    <Flex vertical gap={8}>
                        <SecondaryText>Фото ({photos.length}):</SecondaryText>
                        <Image.PreviewGroup>
                            <Flex gap={8} wrap="wrap">
                                {photos.map((photo) => (
                                    <Image
                                        key={photo}
                                        src={getFileUrl(photo)}
                                        alt=""
                                        width={60}
                                        height={60}
                                        style={{
                                            objectFit: "cover",
                                            borderRadius: 8,
                                        }}
                                    />
                                ))}
                            </Flex>
                        </Image.PreviewGroup>
                    </Flex>
                )}

                {comment && (
                    <Flex vertical gap={4}>
                        <SecondaryText>Коментар:</SecondaryText>
                        <PrimaryText fontSize={14}>{comment}</PrimaryText>
                    </Flex>
                )}

                {children}
            </Flex>
        </StyledCard>
    );
};
